export default __webpack_public_path__ + "static/media/small.03fbf1c3.jpg";